import {
  MessageBar,
  Link
} from '@fluentui/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { isDarkThemeSelector, getCorrelationId } from '../../../web-legacy/packages/app/selectors/contactUsSelector';
import { StyledText } from '../../common/components/StyledText';
import { getString } from '../../utils/stringLoader';
import { capturePageAction, captureContentUpdate } from '../../../web/utils/oneDsUtil';
import { SAMessageBoxSearchCardStyle } from '../styles/selfHelpStyles';
import { commonClassNames } from '../../../web-legacy/packages/contactUs/styles/commonStyles';
import { IContactUsCurrentTheme } from '../../../web-legacy/packages/contactUs/styles/theme.model';
import { appContext } from '../../models/getHelp/appContext';
import { URLs } from '../../../web-legacy/models/constants/constants';

export interface IWin10EndOfSupportCardProps {
  theme?: IContactUsCurrentTheme;
}

const Win10EndOfSupportCardBase = (props: IWin10EndOfSupportCardProps): JSX.Element => {

  const isDarkTheme = useSelector(isDarkThemeSelector);
  const correlationId = useSelector(getCorrelationId);
  const [isVisible, setVisibility] = React.useState(true);
  // Note: the message box styling is the same for both the features
  const messageBarStyles = SAMessageBoxSearchCardStyle(isDarkTheme, props.theme);

  React.useEffect(() => {
    const logHandlerTags = {
      content: {
        contentId: 'Win10EndOfSupportCardShown',
        contentName: 'SurfaceAppGetHelp',
        correlationId: correlationId,
        formnm: 'maxFunnel',
        fileName: 'Win10EndOfSupportCard.tsx',
        areaName: 'GetHelpSection'
      },
      behaviour: 'SHOW',
    };
    captureContentUpdate(logHandlerTags);
  }, []);

  if (!isVisible) {
    return null;
  }

  const onClickDismiss = () => {
    const logHandlerTags = {
      content: {
        contentId: 'Win10EndOfSupportDismissBtn',
        contentName: 'SurfaceAppGetHelp',
        correlationId: correlationId,
        formnm: 'maxFunnel',
        fileName: 'Win10EndOfSupportCard.tsx',
        areaName: 'GetHelpSection'
      },
      behaviour: 'CLICK',
    };
    capturePageAction(null, logHandlerTags);
    setVisibility(false);
  };

  let win10Url = URLs.Win10Eos.replace('{locale}', appContext.locale);
  let officeUrl = URLs.OfficeEos.replace('{locale}', appContext.locale);

  /*
   * Use <MessageBar> and <StyledText> component to match the existing cards shown for various
   * conditions.  However, these won't take an HTML text string, they just render the HTML as
   * text.  Using a <div> with dangerouslySetInnerHTML doesn't account for the existing styles
   * which are generated at runtime in the @fluentui module and, therefore, not available to us.
   */

  // Split the string into parts which will then be used to construct the individual components.
  // string format: text0{0}linkText0{1}text1{2}linkText1{3}text2
  //   where text2 is optional.
  const strResource = getString('win10EndOfSupportAlert');
  const splittingRegex = /\{\d+\}/;
  const parts = strResource.split(splittingRegex);
  const text0 = parts.length > 0 ? parts[0] : null;
  const linkText0 = parts.length > 1 ? parts[1] : null;
  const text1 = parts.length > 2 ? parts[2] : null;
  const linkText1 = parts.length > 3 ? parts[3] : null;
  const text2 = parts.length > 4 ? parts[4] : null;

  const link0 = !!linkText0 ? <Link target="_blank" href={win10Url} rel="noopener noreferrer">{linkText0}</Link> : null;
  const link1 = !!linkText1 ? <Link target="_blank" href={officeUrl} rel="noopener noreferrer">{linkText1}</Link> : null;
  const styledMessage = <StyledText className="styledTextFoo">{text0}{link0}{text1}{link1}{text2}</StyledText>;

  return (
    <MessageBar
      className={commonClassNames.WUSearchflag}
      theme={props.theme}
      messageBarIconProps={{ iconName: 'AlertSolid' }}
      onDismiss={onClickDismiss}
      dismissButtonAriaLabel="Close"
      styles={messageBarStyles}
    >
      {styledMessage}
    </MessageBar>
  );
};
export const Win10EndOfSupportCard: React.FunctionComponent<IWin10EndOfSupportCardProps> = Win10EndOfSupportCardBase;
